import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import Copyright from "./copyright";
import '../css/berita.css';
import data from '../data/beritalain.json'
import channel from '../data/channel.json';
import Dropdown from "react-bootstrap/Dropdown";

export default function Berita() {
    const [jsonData, setJsonData] = useState([]);
    const [jsonChannel, setJsonChannel] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);

    useEffect(() => {
        setJsonData(data);
        setJsonChannel(channel);
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 430);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <section>
            <div className="navbar-berita">
               <Navbar /> 
            </div>
            
            <div className="part-berita">
                <div className="title-berita d-flex justify-content-between align-items-center">
                    {isMobile ? (
                        <Dropdown className="dropdown-campaign dr-berita">
                            <Dropdown.Toggle id="dropdown-basic" className="dropdown-campaign dropdown">
                                Semua
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item className="dropdown-campaign">Semua</Dropdown.Item>
                                <Dropdown.Item className="dropdown-campaign">Kabar Sekolah</Dropdown.Item>
                                <Dropdown.Item className="dropdown-campaign">Prestasi</Dropdown.Item>
                                <Dropdown.Item className="dropdown-campaign">Artikel</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : (
                    <div className="menu1 d-flex
                justify-content-between">
                        <button className="all">Semua</button>
                        <button className="all menu-lain">Kabar Sekolah</button>
                        <button className="all menu-lain">Prestasi</button>
                        <button className="all menu-lain">Artikel</button>
                    </div>
                    )}
                    <div className="carian d-flex align-items-center gap-2">
                        <img src="../../assets/search.svg"></img>
                        <p className="find">Find any news here</p>
                    </div>
                </div>
                <div className="hero-berita beritaa">
                    <div className="d-flex justify-content-between align-items-end">
                        <h1 className="judul-berita">Berita.</h1>
                        <p className="sma">SMA Laboratorium UM</p>
                    </div>
                    <div className="konten-hero">
                        <img src="../../assets/berita/berita.svg" className="cover-berita"></img>
                        <div className="detail-konten">
                            <p className="ks">KABAR SEKOLAH</p>
                            <h1 className="antusias">Antusiasme Siswa Kelas XII Sambut Ujian Praktik</h1>
                            <p className="admin">Admin • 05 Mar, 2024</p>
                        </div>
                    </div>
                </div>
                <div className="hero-berita">
                    <h1 className="terkini">Info terkini</h1>
                    <div className="d-lg-flex d-md-flex justify-content-between">
                        <div className="cover-uprak">
                            <img src="../../assets/berita/uprak.svg" className="uprak"></img>
                            <p className="ks">KABAR SEKOLAH</p>
                            <h1 className="tentang-kabar">Antusiasme Siswa Kelas XII Sambut Ujian Praktik</h1>
                            <p className="deskripsi">Pada tanggal 15 Januari sampai 6 Februari 2024, SMA Lab UM menggelar ujian praktik untuk siswa kelas XII. Ujian ini terintegrasi dalam serangkaian ujian sekolah yang bertujuan untuk mengevaluasi kemampuan siswa dalam menerapkan pengetahuan secara langsung dalam suatu mata pelajaran melalui praktik. Ujian praktik dilakukan pada jam reguler untuk mata pelajaran Agama serta Pendidi...</p>
                            <p className="admin">Admin • 05 Mar, 2024</p>
                        </div>
                        <div>
                            <div className="cover-uprak banjari">
                                <img src="../../assets/berita/banjari.svg" className="uprak"></img>
                                <p className="ks">KABAR SEKOLAH</p>
                                <h1 className="tentang-kabar">Peringatan Isra’ Mi’raj Tingkatkan Kepribadian</h1>
                                <p className="deskripsi">Peristiwa Isra’ Mi’raj memiliki arti penting bagi pembinaan keperibadian manusia, karena dalam peristiwa Isra’ Mi’raj tersebut Nabi menerima perintah shalat lima waktu dalam sehari. Shalat inilah yang merupakan...</p>
                                <p className="admin">Admin • 23 Feb, 2024</p>
                            </div>
                            <div className="cover-uprak banjari d-flex">
                                <img src="../../assets/berita/blank.svg" className="uprak blank"></img>
                                <div>
                                    <p className="ks">ARTIKEL</p>
                                    <h1 className="tentang-kabar ramadhan">Ramadhan bulan penuh berkah</h1>
                                    <p className="admin">Admin • 8 Feb, 2024</p>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="hero-berita">
                    <h1 className="terkini">Berita Lainya</h1>
                    <div className="data-jurnal">
                        {jsonData.map((item, index) => (
                            <div key={index} className="konten-jurnal artikel-berita">
                                <a>
                                    <img src={item.img} className="img-jurnal img-berita" />
                                    <p className="ks">{item.kategori}</p>
                                    <h1 className="item">{item.judul}</h1>
                                    <p className="jan date">{item.nama} • 05 Jan, 2024</p>
                                    <h1 className="detail-jurnal">
                                        {item.detail}
                                    </h1>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="hero-berita">
                    <h1 className="terkini">Whatsapp Channel</h1>
                    <div className="grid">
                        {jsonChannel.map((item, index) => (
                            <a key={index} className="cover-wa">
                                <div className="konten-sosmed cover-wa">
                                    <img src={item.img} className="g-ef praktik"></img>
                                    <p className="effort item">{item.detail}
                                        <span>
                                            <a href="#" className="sp item-sp">
                                                Lihat selengkapnya
                                            </a>
                                        </span>
                                    </p>
                                    <div className="d-flex align-items-center gap-2">
                                        <img src="../../assets/sosmed/whatsapp.svg" className="WA"></img>
                                        <p className="ig" style={{color: "#181818"}}>SMA LABORATORIUM UM OFFICIAL</p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>


            <Footer />
            <Copyright />
        </section>
    )
}